import { getenv } from '~/settings'

import MunchkinTracker from './MunchkinTracker'

const DEFAULT_CONFIG = {
    asyncOnly: true,
    disableClickDelay: true,
}

// http://developers.marketo.com/javascript-api/lead-tracking/
export default class MunchkinApi {
    private readonly appId: string
    private proxy: ReturnType<typeof MunchkinTracker> | null

    constructor() {
        this.appId = getenv('MARKETO_APP_ID')

        // Create an instance of our frozen Munchkin library attached
        // to the window instance we pass if we have a MARKETO_APP_ID.
        this.proxy = this.appId ? MunchkinTracker(window) : null
    }

    init(config = DEFAULT_CONFIG) {
        this.proxy?.init(this.appId, config)
    }

    visitWebPage(urlPath: string, paramString?: string) {
        // Marketo automatically tracks a page visit when
        // the library first inits. To prevent us from calling
        // the same visit a second time, we check to see if this
        // is the first visitWebPage call. If so, we ignore it.
        this.proxy?.munchkinFunction('visitWebPage', {
            url: urlPath,
            params: paramString,
        })
    }

    clickLink(linkHref: string) {
        this.proxy?.munchkinFunction('clickLink', { href: linkHref })
    }

    associateLead<
        T extends {
            id: number
            email: string | null
            munchkinHash: string | null
        },
    >(traits: T) {
        if (traits.munchkinHash != null && traits.email != null) {
            this.proxy?.munchkinFunction(
                'associateLead',
                {
                    Email: traits.email,
                    // FirstName <-- Don't include this, it overwrites the first name in Marketo
                    // LastName <-- Don't include this, it overwrites the first name in Marketo
                    Fictiv_User_ID__c: traits.id, // eslint-disable-line camelcase
                },
                traits.munchkinHash,
            )
        }
    }
}
